import {FC, ReactNode} from 'react'

import {Button} from '@/components/common/content/Button'
import {ButtonVariant} from '@/components/common/content/ButtonTypes'
import {Modal} from '@/components/common/modal/Modal'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Text, TextFontWeight} from '../../content/Text'

type FormTooltipModalProps = {
  tooltipText: ReactNode
  onClose: () => void
  isVisible: boolean
}

export const FormTooltipModal: FC<React.PropsWithChildren<FormTooltipModalProps>> = ({
  tooltipText,
  onClose,
  isVisible,
}) => {
  const {t} = useTranslation()

  const closeModal = (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    onClose()
  }

  return (
    <>
      <Modal
        isVisible={isVisible}
        closeModal={(e) => closeModal(e)}
        hasPadding={false}
        hasCloseIcon={false}
      >
        <div className="content">
          <Text fontWeight={TextFontWeight.regular} element="span">
            {tooltipText}
          </Text>
          <div className="button-wrapper">
            <Button
              variant={ButtonVariant.default}
              type="button"
              fullWidth
              onClick={(e) => closeModal(e)}
            >
              {t('close-btn-text')}
            </Button>
          </div>
        </div>
      </Modal>

      <style jsx>{`
        .content {
          width: 100%;
          height: 100%;
          max-width: 500px;
          white-space: normal;
          text-transform: none;
          padding: ${theme.spacing[5]} ${theme.spacing[5]} 0;
        }
        .button-wrapper {
          text-align: center;
          margin-top: ${theme.spacing[3]};
          padding: ${theme.spacing[2]} 0 ${theme.spacing[3]};
          border-top: 1px solid ${theme.palette.secondary.dark};
        }
        @media ${MOBILE_SCREENSIZE} {
          .content {
            padding: ${theme.spacing[4]} ${theme.spacing[4]} 0;
            text-align: center;
            max-width: inherit;
          }
        }
      `}</style>
    </>
  )
}
